export default "__VITE_ASSET__DfsUh8gT__"